import Text from 'components/generic/typography/components/Text';
import { IText } from 'components/generic/typography/types';
import styled from 'styled-components';

const StyledText = styled(Text)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export default function Variant({ ...restProps }: IText) {
    const { children } = restProps;

    return (
        <StyledText size={10} {...restProps}>
            {children}
        </StyledText>
    );
}
